import { useQuery } from '@tanstack/react-query';

import { TenantPolicy } from '@activepieces/shared';

import { policyApi } from './policy-api';

export const policyHooks = {
  usePolicy: () =>
    useQuery<TenantPolicy>({
      queryKey: ['customer-policy'],
      queryFn: () => policyApi.get(),
      staleTime: 5 * 60 * 1000,
    }),
};
